

<ion-app>
 <ion-router-outlet></ion-router-outlet>

   <!-- <div style="position: fixed; right: 12px; top: 12px; z-index: 9999;">
    <ion-segment [value]="lang" (ionChange)="changeLang($event.detail.value)">
      <ion-segment-button value="ta">
        <ion-label>தமிழ்</ion-label>
      </ion-segment-button>
      <ion-segment-button value="en">
        <ion-label>English</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div> -->
</ion-app>
